module.exports = __webpack_public_path__ + "static/index/img/baikal-509.f0b642b9.jpg";